import React from 'react';

import { Button } from '@change-corgi/design-system-legacy/components/actions';
import { iconDelete } from '@change-corgi/design-system-legacy/icons';
import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';

import type { MediaHitEmbed } from '../../../MediaHitsContainerSunrise/shared/context/types';

import { useDeleteMediaHit } from './hooks/useDeleteMediaHit';

type DeleteMediaHitProps = {
	media: MediaHitEmbed;
	removeMedia: (mediaId: string) => void;
};

export function GammaDeleteMediaHit({ media, removeMedia }: DeleteMediaHitProps): React.JSX.Element | null {
	const {
		data: { canDeleteMediaHit },
		actions: { handleDeleteClick },
	} = useDeleteMediaHit(media, removeMedia);
	const isSunriseThemeEnabled = useIsSunriseTheme();

	if (!canDeleteMediaHit) return null;

	return (
		<Button
			size="small"
			mode="icon"
			icon={iconDelete}
			variant="secondary"
			aria-label={`delete media from ${media.url}`}
			data-testid={`media-hit-${media.id}-delete-button`}
			sx={{
				border: 'none',
				background: isSunriseThemeEnabled ? 'sunrise.semantic.fill.inverse.weak' : 'primary-greyBackground',
				// eslint-disable-next-line @typescript-eslint/naming-convention
				'&:hover': {
					background: 'rgba(0,0,0,0.1)',
				},
				padding: 8,
			}}
			onClick={handleDeleteClick}
		>
			Delete
		</Button>
	);
}
